import React from 'react'
import { FullPageLayout } from '../../components/FullPageLayout'
import PageHeader from '../../components/PageHeader'
import PageTitle from '../../components/PageTitle'
import { Link, useHistory, useParams } from 'react-router-dom'
import routes from '../../helpers/routes'
import { axiosInstance } from '../../utils/axios'
import { Button, Table, Modal, Form } from 'react-bootstrap'
import SubmitButton from '../../components/SubmitButton'
import useModal from '../../hooks/useModal'
import useSubmitting from '../../hooks/useSubmitting'
import AddRecipeItemModal from '../recipes/components/AddRecipeItemModal'
import { Container } from '../common/modules.styles'
import { toLocalDateFormat } from '../../utils/functions'
import toast from 'react-hot-toast'

export default function CustomizeProduction() {
  const addModal = useModal();
  const history = useHistory();
  const { id: productionId } = useParams<{ id: string }>();
  const [production, setProduction] = React.useState<any>(null);
  const [items, setItems] = React.useState<any>([]);
  const [editingIndex, setEditingIndex] = React.useState<number | null>(null);
  const [editingAmount, setEditingAmount] = React.useState<string>('');
  const inputRef = React.useRef<HTMLInputElement | null>(null);
  const [isAnimating, setIsAnimating] = React.useState(false);
  const [aceptChanges, setAceptChanges] = React.useState(0);
  const { isSubmitting, wrap } = useSubmitting();

  const handleAceptChanges = () => {
    setAceptChanges(aceptChanges === 0 ? 1 : 0);
  }

  // traer la producción con el id productionId con useEffect y setearla en el estado production
  React.useEffect(() => {
    // fetch
    (async () => {
      try {
        const response = await axiosInstance(`/productions/get-production/${productionId}`)
        const data = await response.data;
        setProduction(data);
        setItems(data.recipe.items);
      } catch (error) {
        console.error(error)
      }
    })()
  }, [productionId])

  const addItem = (item: any) => {
    setItems([...items, item]);
  }

  const removeItem = (index: number) => {
    setItems(items.filter((_: any, idx: number) => idx !== index));
    // if we were editing this index, cancel edit
    if (editingIndex === index) {
      setEditingIndex(null);
      setEditingAmount('');
    }
  }

  const startEdit = (index: number) => {
    setEditingIndex(index);
    setEditingAmount(String(items[index].amount ?? ''));
    // trigger animation and focus shortly after modal opens
    setIsAnimating(true);
    window.setTimeout(() => setIsAnimating(false), 700);
  }

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditingAmount('');
    setIsAnimating(false);
  }

  const saveEdit = (index: number) => {
    const parsed = parseFloat(editingAmount as string);
    if (isNaN(parsed) || parsed <= 0) {
      toast.error('Ingrese una cantidad válida mayor que 0');
      return;
    }
    const updated = items.map((it: any, idx: number) => idx === index ? { ...it, amount: parsed } : it);
    setItems(updated);
    setEditingIndex(null);
    setEditingAmount('');
    setIsAnimating(false);
  }

  // focus input when modal opens
  React.useEffect(() => {
    if (editingIndex !== null) {
      // small delay to allow modal animation/mount
      const t = window.setTimeout(() => {
        try {
          inputRef.current?.focus();
          inputRef.current?.select();
        } catch (e) { /* ignore */ }
      }, 120);
      return () => window.clearTimeout(t);
    }
  }, [editingIndex]);

  const handleSubmitChanges = wrap(async () => {
    try {
      console.log(items);
      const response = await axiosInstance.post('/productions/customize-production', { productionId, items });
      console.log(response.data);
      toast.success('Producción completada');
      history.push('..');
    } catch (error: any) {
      // keep previous behavior: show backend error message when available
      toast.error(error?.response?.data || 'Error al guardar cambios');
    }
  });


  return (
    <FullPageLayout>
      <Container>
        <style>{`
          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 rgba(13,110,253,0.35); }
            70% { box-shadow: 0 0 0 10px rgba(13,110,253,0); }
            100% { box-shadow: 0 0 0 0 rgba(13,110,253,0); }
          }
          .pulse-input {
            animation: pulse 0.7s ease-out;
            border-color: #0d6efd !important;
            outline: none !important;
          }
        `}</style>
        <PageHeader>
          <PageTitle title="Personalizar Producción" />
          <Link className="btn btn-secondary" to={routes.productions.index}>Volver</Link>
        </PageHeader>
        <div>
          {production &&
            <div>
              <h3>{production.recipe.name}</h3>
              <p>Fecha de producción: {toLocalDateFormat(production.date)}</p>
              <div className="mt-3" style={{ display: 'flex', justifyContent: "space-between", alignContent: "center" }}>
                <h3>Componentes de la receta</h3>
                <Button size="sm" variant="outline-primary" onClick={() => addModal.toogleModal()}>Agergar insumo</Button>
              </div>
              <Table bordered size="sm" className="mt-3">
                <thead>
                  <tr>
                    <th>Insumo</th>
                    <th>Cantidad</th>
                    <th>Unidad</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>{item.input.name}</td>
                      <td>
                        <span>{item.amount}</span>
                      </td>
                      <td>{item.unit}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                          <Button size="sm" variant="outline-secondary" onClick={() => startEdit(index)} title="Modificar" aria-label={`Modificar ${item.input.name}`}>
                            ✏️
                          </Button>
                          <Button size="sm" variant="outline-danger" onClick={() => removeItem(index)} title="Eliminar" aria-label={`Eliminar ${item.input.name}`}>
                            🗑️
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {/* Edit modal for adjusting amount on small screens */}
              <Modal show={editingIndex !== null} onHide={cancelEdit} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Modificar cantidad</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group>
                    <Form.Label>Insumo</Form.Label>
                    <Form.Control readOnly value={editingIndex !== null ? items[editingIndex].input.name : ''} />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Cantidad</Form.Label>
                    <Form.Control
                      type="number"
                      value={editingAmount}
                      onChange={(e) => setEditingAmount(e.target.value)}
                      ref={inputRef}
                      className={isAnimating ? 'pulse-input' : ''}
                      min={0}
                    />
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={cancelEdit}>Cancelar</Button>
                  <Button variant="primary" onClick={() => editingIndex !== null && saveEdit(editingIndex)}>Guardar</Button>
                </Modal.Footer>
              </Modal>
              <AddRecipeItemModal show={addModal.isOpenModal} toogle={addModal.toogleModal} addFunction={addItem} />
            </div>
          }
        </div>
        <div>
          {/* agregar switch para indicar que se realizaron los cambios, si se activa este switch recien se puede hacer click en el botón para guardar los caambios */}
          <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" value={aceptChanges} onChange={handleAceptChanges} />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Cambios realizados</label>
          </div>
          <SubmitButton className="mt-1" variant="primary" disabled={!aceptChanges} isSubmitting={isSubmitting} onClick={handleSubmitChanges} submittingText={"Guardando..."}>
            Guardar cambios
          </SubmitButton>
        </div>
      </Container>
    </FullPageLayout>
  )
}
